import  "bootstrap";
import {Scroll} from "./modules/scroll";
import {Menu} from "./modules/menu";
import {More} from "./modules/more";
import {Header} from "./modules/header";
import "./myfont.font";
import {CopyText} from "./modules/copytext"

Menu();
More();
Scroll();
Header();
CopyText();


new ClipboardJS('.copyBtn');
